import React from 'react';
import { Loader2 } from 'lucide-react';
import styles from './Spinner.module.css';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 'md', className }) => {
  const sizeMap = {
    sm: 16,
    md: 24,
    lg: 32,
  };

  return (
    <div className={`${styles.container} ${className ?? ''}`}>
      <Loader2 className={styles.spinner} size={sizeMap[size]} />
    </div>
  );
};

